import { render, staticRenderFns } from "./AutomatedResponsesPreferenceSettings.vue?vue&type=template&id=462f93dc&scoped=true&"
import script from "./AutomatedResponsesPreferenceSettings.vue?vue&type=script&lang=js&"
export * from "./AutomatedResponsesPreferenceSettings.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedResponsesPreferenceSettings.vue?vue&type=style&index=0&id=462f93dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f93dc",
  null
  
)

export default component.exports